export const MAIN_COLORS = {
  primary: {
    main: '#6F5AF2',
    alt: '#0064B1',
    nuna: '#C5E04C',
  },
  secondary: {
    main: '#DDF3FF',
    alt: '#153142',
    second: '#2c74ffff',
  },
  success: {
    main: '#66BB6A',
  },
  warning: {
    main: '#F79572',
  },
  error: {
    main: '#FF3F3F',
    alt: '#EB2B2B',
  },
  white: {
    main: '#EFEFEF',
    alt: '#FFFFFF',
    second: '#f7f7f7ff',
  },
  black: {
    main: '#000000',
  },
  gray: {
    main: '#88898B',
  },
}

export const COLORS = {
  primary: {
    main: MAIN_COLORS.primary.main,
    alt: MAIN_COLORS.primary.alt,
  },
  text: {
    main: MAIN_COLORS.white.main,
    white: MAIN_COLORS.white.alt,
    whiteAlt: MAIN_COLORS.white.second,
    alt: MAIN_COLORS.secondary.alt,
    nuna: MAIN_COLORS.primary.nuna,
    black: MAIN_COLORS.black.main,
  },
  error: {
    main: MAIN_COLORS.error.main,
    alt: MAIN_COLORS.error.alt,
  },
  background: {
    main: MAIN_COLORS.white.main,
    alt: MAIN_COLORS.primary.main,
    black: MAIN_COLORS.black.main,
  },
  border: {
    main: MAIN_COLORS.primary.main,
  },
  button: {
    main: MAIN_COLORS.primary.main,
    alt: MAIN_COLORS.primary.main,
    second: MAIN_COLORS.secondary.second,
    nuna: MAIN_COLORS.primary.nuna,
  },
  warning: {
    main: MAIN_COLORS.warning.main,
  },
}
